<template>
    <v-card flat>
        <v-card-title class="text-h5 justify-space-around pt-2 pb-0" :class="[{ 'mb-12': !intrusion.isactive }]">
            <p>UTC : <strong>{{ imageDescription.Denomination }}</strong> ({{ imageDescription.SerialNb }})</p>
            <p>Date : <strong>{{ imageDescription.Date }}</strong></p>
            <p>{{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.time') }} : <strong>{{ imageDescription.Time }}</strong></p>
        </v-card-title>
        <v-row v-if="intrusion.isactive" justify="center" align="center" class="blink mb-2" dense>
            <v-col cols="auto">
                <v-icon color="red">mdi-motion-sensor</v-icon>
            </v-col>
            <v-col cols="auto">
                <v-card-title class="red--text py-0">
                    {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.thisintrusionisactive') }}
                </v-card-title>
            </v-col>
        </v-row>
        <v-carousel
            delimiter-icon="mdi-minus-thick"
            :show-arrows="images.length > 1"
            height="650"
            @change="readMetadata"
            hide-delimiters
        >
            <v-carousel-item
                v-for="(image, index) in images"
                :key="image.name"
            >
                <v-container class="pt-10">
                    <v-row justify="space-between">
                        <v-col cols="auto">
                            <v-skeleton-loader v-if="image.loading" type="image"></v-skeleton-loader>                           
                            <template v-else>
                                <div class="imageContainer ml-11">
                                    <canvas
                                        :id="'output'+index"
                                        :width="webImageWidth"
                                        :height="webImageHeight"
                                        style="border: solid black 1px"
                                    ></canvas>
                                    <p class="filename">{{ images[currentIndex].name }}</p>
                                    <p class="temperatureMaxAlarm">{{ imageDescription.TemperatureMax }} °C</p>
                                    <p class="temperatureMinAlarm">{{ imageDescription.TemperatureMin }} °C</p>
                                </div>
                            </template>
                            
                            <img :id="'input'+index" style="display: none" :width="utcImageWidth" :height="utcImageHeight" :src="imageSrc" @load.once="loadOutput(index)">
                        </v-col>
                        <v-col cols="5" class="pt-0">
                            <v-card flat :height="webImageHeight">
                                <v-card-title  > <strong>{{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.basicinformations') }}</strong></v-card-title>
                                <v-card-text>
                                    <div class="text-subtitle-1 font-weight-bold mt-5">{{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.environment') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-thermometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.temperature') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.TemperatureEnv ? Math.round((imageDescription.TemperatureEnv -5) * 100) / 100 : $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.TemperatureEnv"> °C</template>
                                            </v-col>
                                        </v-row>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-water-percent</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.humidity') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.HumidityEnv ? Math.round(imageDescription.HumidityEnv * 100) / 100 : $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.HumidityEnv"> %RH</template>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <div class="text-subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.configuration') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-speedometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.triggerthreshold') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ securityClassification.Threshold ? securityClassification.Threshold : $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.notavailable') }}</strong>
                                                <template v-if="securityClassification.Threshold"> °C</template>
                                            </v-col>
                                        </v-row>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-eye-arrow-left-outline</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.emissivity') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.emissivity ? imageDescription.emissivity : $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.notavailable') }}</strong>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <div class="text-subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.internal') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto" class="pr-0">
                                                <v-icon color="black">mdi-thermometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto" class="pl-0">
                                                <v-icon color="black">mdi-memory</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.fpatemperature') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.TemperatureFPA ? imageDescription.TemperatureFPA : $vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.TemperatureFPA"> °C</template>
                                            </v-col>
                                        </v-row>
                                </v-card-text>
                            </v-card> 
                        </v-col>
                    </v-row>
                </v-container>
            </v-carousel-item>
        </v-carousel>
        <v-card-actions>
            <v-spacer />
            <v-spacer />
            <strong>Image {{ (currentIndex + 1) }} / {{ images.length }}</strong>     
            <v-spacer />   
            <v-btn :class="intrusion.isconsulted ? '' : 'gradient-wintech'" :disabled="intrusion.isconsulted" :loading="ackLoading" @click="acknowledge(intrusion.id)">
                <v-icon left>mdi-eye</v-icon>
                {{this.$vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.acknowledge')}}
            </v-btn>
            <v-btn class="gradient-wintech" @click="downloadintrusionFolder(intrusion.folder)">
                <v-icon left>mdi-download</v-icon>
                {{this.$vuetify.lang.t('$vuetify.intrusion.intrusionDetailsCard.download')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from 'axios';
import JSZip from 'jszip';
import exifr from 'exifr';
import { mapGetters } from 'vuex';
import cv from '../../plugins/opencv';

export default {
    name: "IntrusionsDetailsCard",
    props: {
        intrusion: Object,
        images: Array,
    },
    data() {
        return {
            ackLoading: false,
            imageDescription: {
                DateTime: "1970-01-01 00:00:00",
                Date: undefined,
                Time: undefined,
                Denomination: "",
                SerialNb: "",
                TemperatureEnv: undefined,
                HumidityEnv: undefined,
                TemperatureFPA: undefined,
                TemperatureMax: undefined,
                TemperatureMin: undefined,
                TemperatureMaxTotal: undefined,
                TemperatureMinTotal: undefined,
            },
            securityClassification: {
                intrusionFolder: "",
                Threshold: "70",
            },
            indicatorHeights: [],
            currentIndex: 0,
            webImageWidth: 550,
            webImageHeight: 423,
            utcImageWidth: 170,
            utcImageHeight: 120,
            utcColormapWidth: 10
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
        isTiff() {
            return this.images[this.currentIndex].tiff !== undefined;
        },
        imageSrc() {
            return this.isTiff ? undefined : this.images[this.currentIndex].url;
        },

        utcImageWidthWithoutColormap() {
            return this.utcImageWidth - this.utcColormapWidth
        },
        measurements() {
            return [
                {
                    name: "$vuetify.intrusion.intrusionDetailsCard.masksexcluded",
                    max: this.imageDescription.TemperatureMax,
                    min: this.imageDescription.TemperatureMin
                },
                {
                    name: "$vuetify.intrusion.intrusionDetailsCard.masksincluded",
                    max: this.imageDescription.TemperatureMaxTotal,
                    min: this.imageDescription.TemperatureMinTotal
                }
            ]
        },
    },
    
    methods: {
        async acknowledge(intrusionId) {
            console.log('intrusionId: ', intrusionId)
            this.ackLoading = true;
            const res = await axios.put('intrusions/'+intrusionId);
            if (res.status == 200) {
                this.intrusion.isconsulted = true;
            }
            this.ackLoading = false;            
        },

        async downloadintrusionFolder(folder) {
            var zip = new JSZip();
            for (const i in this.images) {
                zip.file(this.images[i].name, this.images[i].blob);
            }
            const content = await zip.generateAsync({type: "blob"});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = folder + '.zip';
            document.body.appendChild(link);
            link.dispatchEvent(
                new MouseEvent('click', { 
                    bubbles: true, 
                    cancelable: true, 
                    view: window 
                })
            );
            document.body.removeChild(link);
        },

        async readMetadata(index) {
            this.currentIndex = index;
            try {
                let output = await exifr.parse(this.images[index].blob, true);
                let imageDescription = JSON.parse(output['ImageDescription'].replace(/'/g, "\""));
                let datetime = new Date(imageDescription.DateTime);
                imageDescription.Date = datetime.getDate().toString().padStart(2, '0') + "/" + (1 + datetime.getMonth()).toString().padStart(2, '0') + "/" + datetime.getFullYear();
                imageDescription.Time = datetime.getHours().toString().padStart(2, '0') + ":" + datetime.getMinutes().toString().padStart(2, '0') + ":" + datetime.getSeconds().toString().padStart(2, '0');
                this.imageDescription = imageDescription;
                let securityClassification = {};
                if (output[37394]) {
                    securityClassification = JSON.parse(output[37394].replace(/'/g, "\""))
                } else {
                    securityClassification = {
                        Threshold: imageDescription.threshold,
                    };
                }
                this.securityClassification = securityClassification;
            } catch(err) {
                if (err instanceof TypeError) {
                    return;
                } else {
                    console.error(err);
                }
            }
            if (this.isTiff) this.loadOutput(index);
        },

        loadOutput(index) {
            var src;
            if (this.isTiff) {
                src = cv.matFromArray(this.utcImageHeight, this.utcImageWidth, cv.CV_8UC3, this.images[index].tiff[0].data);             
            } else {
                let input = document.getElementById('input'+index);
                src = cv.imread(input);
            }
            let dst = new cv.Mat();
            let dsize = new cv.Size(this.webImageWidth, this.webImageHeight);
            cv.resize(src, dst, dsize, 0, 0, cv.INTER_AREA);
            
            let output = document.getElementById('output'+index);
            cv.imshow(output, dst);
            src.delete(); dst.delete();
        },
    }
}
</script>

<style lang="scss" scoped>

    .blink {
        animation: blink-animation 1s steps(3, start) infinite;
        -webkit-animation: blink-animation 1s steps(3, start) infinite;
    }
    @keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }
    @-webkit-keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    .imageContainer {
        position: relative;
        text-align: center;
        color: black;
    }

    .filename {
        position: absolute;
        bottom: -36px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .temperatureMaxAlarm {
        position: absolute;
        top: -24px;
        right: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .temperatureMinAlarm {
        position: absolute;
        bottom: -36px;
        right: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .currentTemperatureAlarm {
        display: none;
        position: absolute;
        right: -62px;
        color: red;
        font-weight: 500;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 !important;
    }
</style>
